// VEYSA - Alquiler de Vehiculos (Madrid Norte)
// Datos de tarifas MOCK extraidos del documento de tarifas adjunto.
// Toda la logica de precios se calcula en el navegador (frontend-only).

export const COMPANY = {
  name: "VEYSA",
  tagline: "ALQUILER DE VEHÍCULOS",
  location: "Madrid Norte",
  address: "C. Cancheras, 1, nave E2-02",
  city: "28750 San Agustín del Guadalix, Madrid",
  tel: "918 418 180",
  telHref: "+34918418180",
  mobile: "+34 695 292 062",
  mobileHref: "+34695292062",
  email: "info@veysa.es",
};

// Icono: 'car' | 'van' | 'passengers'
export const VEHICLES = [
  {
    group: "A",
    name: "Urbano Compacto (Fiat 500)",
    fullName: "Urbano Compacto",
    type: "Turismo",
    detail: "4 plazas",
    icon: "car",
    weekday: 32,
    weekend: 57.6,
    week: 224,
    fianza: 500,
    kmDay: 200,
  },
  {
    group: "B",
    name: "Turismo / Compacto (Citroën C4)",
    fullName: "Turismo / Compacto",
    type: "Turismo",
    detail: "5 plazas",
    icon: "car",
    weekday: 45,
    weekend: 81,
    week: 315,
    fianza: 600,
    kmDay: 200,
  },
  {
    group: "C",
    name: "Furgoneta Pequeña / Carga (Fiat Doblò)",
    fullName: "Furgoneta Pequeña / Carga",
    type: "Comercial Pequeña",
    detail: "3,3 – 4,2 m³",
    icon: "van",
    weekday: 55,
    weekend: 99,
    week: 385,
    fianza: 600,
    kmDay: 250,
  },
  {
    group: "D",
    name: "Furgoneta Mediana / Carga (Peugeot Expert)",
    fullName: "Furgoneta Mediana / Carga",
    type: "Comercial Mediana",
    detail: "5,3 – 6,6 m³",
    icon: "van",
    weekday: 68,
    weekend: 122.4,
    week: 476,
    fianza: 600,
    kmDay: 300,
  },
  {
    group: "E",
    name: "Furgoneta Grande / Carga L3H2 (Mercedes Spinter)",
    fullName: "Furgoneta Grande / Carga L3H2",
    type: "Comercial Gran Volumen",
    detail: "11 – 13 m³",
    icon: "van",
    weekday: 85,
    weekend: 153,
    week: 595,
    fianza: 700,
    kmDay: 350,
  },
  {
    group: "F",
    name: "Minivan / Pasajeros (Mercedes Vito 9 Plazas)",
    fullName: "Minivan / Pasajeros",
    type: "Pasajeros Premium",
    detail: "9 plazas + maletero",
    icon: "passengers",
    weekday: 182,
    weekend: 327.6,
    week: 1274,
    fianza: 800,
    kmDay: 350,
  },
];

// Coberturas de seguro. precioDia y fianza por grupo (A-F).
export const INSURANCES = [
  {
    id: "basico",
    name: "Básico",
    desc: "Cobertura estándar con franquicia completa.",
    icon: "shield",
    // precio incluido; fianza = estandar del vehiculo
    perDay: { A: 0, B: 0, C: 0, D: 0, E: 0, F: 0 },
    fianza: { A: 500, B: 600, C: 600, D: 600, E: 700, F: 800 },
    fianzaLabel: "estándar",
  },
  {
    id: "medio",
    name: "Medio",
    desc: "Reduce la franquicia y la fianza un 50%.",
    icon: "shield-half",
    perDay: { A: 9, B: 12, C: 12, D: 15, E: 18, F: 20 },
    fianza: { A: 250, B: 300, C: 300, D: 300, E: 350, F: 400 },
    fianzaLabel: "reducida",
  },
  {
    id: "premium",
    name: "Premium",
    desc: "Franquicia Cero (SCDW). Sin fianza retenida.",
    icon: "shield-check",
    perDay: { A: 18, B: 22, C: 22, D: 28, E: 32, F: 35 },
    fianza: { A: 0, B: 0, C: 0, D: 0, E: 0, F: 0 },
    fianzaLabel: "cero",
  },
];

// Codigos promocionales. Solo se aplica uno de los dos.
export const PROMOS = {
  BIENVENIDO2026: {
    code: "BIENVENIDO2026",
    rate: 0.2,
    label: "Promoción 1ª reserva (−20%)",
    note: "Excluido seguro y franquicias.",
  },
  FINDE: {
    code: "FINDE",
    rate: 0.1,
    label: "Promoción fin de semana (−10%)",
    note: "Aplicable al alquiler del vehículo.",
  },
};

export const EXTRAS = {
  outOfHoursFee: 35,
};

export const SCHEDULE = [
  { day: "Lunes – Viernes", hours: "8:30 – 14:00 y 15:00 – 20:00" },
  { day: "Sábado", hours: "8:30 – 14:00" },
  { day: "Domingo", hours: "Cerrado · solo devoluciones (buzón)" },
];
